module.exports = __webpack_public_path__ + "static/media/pandaz.39cd8b59.svg";